import { render, staticRenderFns } from "./SelectProfile.vue?vue&type=template&id=35ddaad8&scoped=true"
import script from "./SelectProfile.vue?vue&type=script&lang=js"
export * from "./SelectProfile.vue?vue&type=script&lang=js"
import style0 from "./SelectProfile.vue?vue&type=style&index=0&id=35ddaad8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ddaad8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35ddaad8')) {
      api.createRecord('35ddaad8', component.options)
    } else {
      api.reload('35ddaad8', component.options)
    }
    module.hot.accept("./SelectProfile.vue?vue&type=template&id=35ddaad8&scoped=true", function () {
      api.rerender('35ddaad8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/SelectProfile.vue"
export default component.exports